import {Component, Input, OnChanges} from '@angular/core';
import {MatrixTotalTableData} from './matrix-total-table-data';

@Component({
  selector: 'app-matrix-total-table',
  templateUrl: './matrix-total-table.component.html',
  styleUrl: '../../../../cockpit-shared/contents/cockpit-styles.scss',
  standalone: false
})
export class MatrixTotalTableComponent implements OnChanges {
  @Input() data: MatrixTotalTableData;
  @Input() columnHeader: string;
  @Input() rowHeader: string;

  public rowCount: number;
  public colCount: number;

  ngOnChanges(): void {
    if (this.data) {
      this.rowCount = this.data.matrix.length;
      this.colCount = this.data.matrix[0].length;
    }
  }
}
